import React from "react";
import styled from "styled-components";

export default function SectionTop({
	heading,
	description,
	bottomSpace,
	shrinkHeading,
	fullHeading,
	stretchHeading,
}) {
	return (
		<Wrapper
			bottomSpace={bottomSpace}
			shrinkHeading={shrinkHeading}
			fullHeading={fullHeading}
			stretchHeading={stretchHeading}
		>
			<h2 className="bolder ">{heading && heading}</h2>

			<p className="small">{description && description}</p>
		</Wrapper>
	);
}

const Wrapper = styled.div`
	margin-bottom: ${(props) => "3.2rem"};
	text-align: center;

	* {
		margin: 0 auto;
		width: 100%;
		text-align: center;
	}

	h2 {
		/* width: ${(props) => (props.shrinkHeading ? "30%" : "40%")};
		width: ${(props) => props.fullHeading && "50% !important"};
		width: ${(props) => props.stretchHeading && "100% !important"};
		width: ${(props) => "100% !important"}; */
		font-size: ${(props) => props.stretchHeading && ""};
		margin-bottom: 0.8rem;
		color: #024ca3;
	}

	p {
		span {
			display: block;
		}
	}

	@media (max-width: 768px) {
		margin-bottom: ${(props) => "2rem"};

		h2 {
			width: 55% !important;
			/* width: ${(props) => props.fullHeading && "50% !important"}; */
		}

		p {
			width: 80%;
		}
	}
`;
